import { Documents } from './documents';


export namespace Reports {
    export interface ReportSetting {
        Key: string;
        Value: string;
    }

    export interface ReportDictItem {
        Uid: string;
        Code: string;
        Name: string;
    }

    export interface ReportType {
        Uid: string;
        Code: string;
        Name: string;
        SendTo: string;
        AutoGeneration: boolean;
        NextDateGeneration: Date;
        GenerationDelayInDays: number;
        ReportTypeSettings: ReportSetting[];
        ReportPeriod: ReportDictItem;
    }

    export enum ReportStatuses {
        new = 'new',
        inprocess = 'inprocess',
        finished = 'finished',
        error = 'error',
    }

    export interface Report {
        ReportNumber: string;
        Uid: string;
        ReportStatusCode: ReportStatuses;
        ReportStatusName: string;
        ReportTypeCode: string;
        UserUid: string;
        CreateDate: Date;
        ErrorMessage?: string;
        ReportSettings: ReportSetting[];
    }

    export interface BappReport extends Report {
        File: Documents.Document;
    }
}
